import { homeResponse } from '../../testHelpers/mockData/homeResponse';
export interface TeamSummary {
  id: string;
  sport: string;
  ageLevel: string;
  nameLong: string;
  nameHandleLower: string;
  nameLocation: string;
  imageLogo: {
    small: string;
    large: string;
  };
  roles: string[];
}

export interface ClaimedPlayerSummary {
  id: string;
  nameFirst: string;
  nameLast: string;
  nameHandle: string;
  yearGraduation: number;
  positionPrimary: string;
  imageUrlSmall: string;
  roles: string[];
  isDkPaired: boolean;
  collegeCommitName: string;
  primarySport: string;
  positions: {
    [sport: string]: {
      primary?: string;
      secondary?: string;
    };
  };
}

export interface ClaimedPlayerResponse {
  player: ClaimedPlayerSummary;
  teams: TeamSummary[];
}
export interface homeResponse {
  claimedPlayers: ClaimedPlayerResponse;
  teams: TeamSummary[];
}

export enum TeamRole {
  Admin = 'Admin',
  Coach = 'Coach',
  Follower = 'Follower',
}

export enum ClaimedPlayerRole {
  Manager = 'Manager',
  Follower = 'Follower',
}
